import React from 'react';
import Packages from '../Packages';

function AgencyPackages({ selectedUserId }) {
  return (
    <Packages selectedUserId={selectedUserId} />
  );
}

export default AgencyPackages;


